import React, { PropsWithChildren, ReactNode } from 'react';
import {
  Alert,
  AlertProps,
  Box,
  Button,
  Link,
  Snackbar as MuiSnackbar,
  SnackbarProps as MuiSnackbarProps,
} from '@mui/material';

export type SnackbarProps = PropsWithChildren<{
  readonly message?: ReactNode;
  readonly link?: string;
  readonly action?: { text: string; onClick: () => void };
  readonly snackbarProps?: MuiSnackbarProps;
  readonly iconProps?: AlertProps;
}>;

const Snackbar = ({
  children,
  snackbarProps,
  iconProps,
  message,
  link,
  action,
}: SnackbarProps) => {
  return (
    <>
      {children}
      <MuiSnackbar {...snackbarProps}>
        <Alert
          {...iconProps}
          sx={{
            width: '100%',
            '&.MuiPaper-root': {
              borderRadius: '8px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '12px',
            },
            '& .MuiAlert-icon': {
              margin: 0,
            },
            '& .MuiAlert-message': {
              fontSize: '14px',
              fontStyle: 'normal',
              fontWeight: 400,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '20px',
            },
            '.MuiAlert-action': {
              padding: 0,
            },
            '.alert-link': {
              fontSize: '12px',
              textDecoration: 'underline',
            },
            '.alert-button': {
              padding: 0,
              fontSize: '12px',
              color: 'inherit',
              '&:hover': {
                backgroundColor: 'transparent',
                textDecoration: 'underline',
              },
            },
          }}
        >
          {message}
          {link && (
            <Box>
              <Link href={link} target={'_blank'} className={'alert-link'}>
                보러가기 →
              </Link>
            </Box>
          )}
          {action && (
            <Box>
              <Button
                onClick={(event) => {
                  event.stopPropagation();
                  action.onClick();
                  snackbarProps?.onClose?.(event, 'clickaway');
                }}
                className={'alert-button'}
              >
                {action.text}
              </Button>
            </Box>
          )}
        </Alert>
      </MuiSnackbar>
    </>
  );
};

export default Snackbar;
